import { render } from "./userVerification.vue?vue&type=template&id=25e5b140"
import script from "./userVerification.vue?vue&type=script&lang=js"
export * from "./userVerification.vue?vue&type=script&lang=js"

import "./userVerification.vue?vue&type=style&index=0&id=25e5b140&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__